module.exports = __webpack_public_path__ + "static/media/Glam Rock Kitchen.d6bd118f.png";